import ChangePassword from "../views/ChangePassword/ChangePassword";
import { UsersView } from "../views/UsersSection/UsersView";
import { UserDetails } from "../views/UsersSection/UserDetails";

import DashboardIcon from "@material-ui/icons/Dashboard";
import GroupIcon from "@material-ui/icons/Group";

export const usersRoutes = [
  {
    path: "/cambiar_contrasena_usuario/:id",
    name: "Cambiar contraseña",
    icon: DashboardIcon,
    component: ChangePassword,
    layout: "/admin",
    sublayout: "/cambiar_contrasena_usuario",
    isEdit: true,
    inSidebar: false,
  },
  //----------------------//
  {
    collapse: true,
    name: "Usuarios",
    icon: GroupIcon,
    state: "usersSection",
    inSidebar: true,
    isProtected: true,
    rule: "USERS",
    views: [
      {
        path: "/usuarios_menu",
        name: "Usuarios",
        mini: "US",
        component: UsersView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "USERS",
      },
      {
        path: "/usuario_detalles/:id",
        component: UserDetails,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: "USERS",
      },
    ],
  },
]